<template>
  <v-layout>
    <v-select v-model="selectedItem" label="Clavien-Dindo" clearable :items="clavienDindoItems" />
    <v-checkbox
      :disabled="value.length === 0"
      :value="value.includes('d')"
      label="Disfunção"
      class="ml-2"
      @change="onCheck"
      @click:clear="() => selectedItem = ''"
    />
  </v-layout>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      disability: false
    }
  },
  computed: {
    selectedItem: {
      get() {
        return this.value.replace('d', '')
      },
      set(newClavienDindo) {
        this.$emit('input', newClavienDindo ? newClavienDindo : '')
      }
    },
    clavienDindo() {
      if (!this.selectedItem) return ''
      return `${this.selectedItem}${this.disability ? 'd' : ''}`
    },
    clavienDindoItems() {
      return [
        { value: 'i', text: 'I' },
        { value: 'ii', text: 'II' },
        { value: 'iiia', text: 'III-a' },
        { value: 'iiib', text: 'III-b' },
        { value: 'iv', text: 'IV' },
        { value: 'iva', text: 'IV-a' },
        { value: 'ivb', text: 'IV-b' },
        { value: 'v', text: 'V' },
        { value: 'vi', text: 'VI' }
      ]
    }
  },
  watch: {
    disability() {
      this.$emit('input', this.clavienDindo)
    }
  },
  methods: {
    onCheck(checked) {
      this.disability = checked
    }
  }
}
</script>

<style>
</style>